module.exports = __webpack_public_path__ + "static/hkt2-f185dc05bfc15441c31f61deff20d06f.jpg";